<!-- eslint-disable max-len -->
<template>
  <div
    class="
      block
      relative
      walter-block
      bg-white
      mb-2
      overflow-hiddens
      accordian-block
    "
  >
    <div class="card tab">
      <input
        id="tab-single2"
        class="card-heading absolute opacity-0"
        type="checkbox"
        name="tabs1"
      />
      <label
        class="
          card-heading
          cursor-pointer
          flex
          items-center
          justify-between
          mb-0
          pt-3
          pb-3
          rounded-t-lg
          tab
          w-full
          border-b
          solid
          border-agray1
        "
        for="tab-single2"
      >
        <span class="block relative text-sm font-bold text-darkblack">
          {{ $t("pages.questionnaire.second_collapse.label") }}
        </span>
        <span class="flex transform rotate-180 duration-100 iconbox">
          <svg
            class="w-4 h-4"
            viewBox="0 0 16 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.4957 7.50767C14.3637 7.50455 14.2382 7.44932 14.1467 7.35403L8.00025 1.20754L1.85377 7.35403C1.80716 7.40202 1.7514 7.44018 1.68978 7.46623C1.62817 7.49229 1.56195 7.50572 1.49505 7.50572C1.39554 7.5057 1.2983 7.47598 1.21577 7.42039C1.13325 7.36479 1.06919 7.28583 1.03178 7.19362C0.994383 7.10141 0.985343 7.00014 1.00582 6.90276C1.0263 6.80538 1.07536 6.71633 1.14674 6.647L7.64674 0.146995C7.74051 0.0532622 7.86767 0.000607491 8.00025 0.000607491C8.13284 0.000607491 8.26 0.0532622 8.35377 0.146995L14.8538 6.647C14.9265 6.71678 14.9764 6.80691 14.997 6.90556C15.0176 7.00422 15.0079 7.10679 14.9692 7.19984C14.9305 7.29289 14.8646 7.37207 14.7801 7.427C14.6956 7.48193 14.5964 7.51005 14.4957 7.50767Z"
              fill="white"
            ></path>
          </svg>
        </span>
      </label>
      <div class="tab-content overflow-hidden card-body rounded-b-lg">
        <div class="block relative pl-4 pr-4 pt-2 pb-4">
          <div class="situation-block block">
            <label
              class="
                flex
                items-center
                justify-start
                relative
                text-sm
                font-semibold
                text-darkblack
                mb-3
              "
            >
              {{ $t("pages.questionnaire.second_collapse.title") }}
              <span class="flex ml-2.5" @click="isInfoModal = !isInfoModal">
                <svg
                  class="w-3.5 h-3.5"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.99998 0.333008C3.324 0.333008 0.333313 3.3237 0.333313 6.99967C0.333313 10.6757 3.324 13.6663 6.99998 13.6663C10.676 13.6663 13.6666 10.6757 13.6666 6.99967C13.6666 3.3237 10.676 0.333008 6.99998 0.333008ZM6.99998 1.33301C10.1355 1.33301 12.6666 3.86414 12.6666 6.99967C12.6666 10.1352 10.1355 12.6663 6.99998 12.6663C3.86444 12.6663 1.33331 10.1352 1.33331 6.99967C1.33331 3.86414 3.86444 1.33301 6.99998 1.33301ZM6.99998 3.33301C5.90136 3.33301 4.99998 4.23439 4.99998 5.33301V5.49967C4.99904 5.56593 5.01128 5.63171 5.03599 5.6932C5.0607 5.75468 5.09738 5.81064 5.1439 5.85783C5.19042 5.90501 5.24586 5.94248 5.30699 5.96805C5.36812 5.99363 5.43372 6.0068 5.49998 6.0068C5.56624 6.0068 5.63184 5.99363 5.69297 5.96805C5.7541 5.94248 5.80954 5.90501 5.85606 5.85783C5.90258 5.81064 5.93926 5.75468 5.96397 5.6932C5.98868 5.63171 6.00092 5.56593 5.99998 5.49967V5.33301C5.99998 4.77496 6.44194 4.33301 6.99998 4.33301C7.55802 4.33301 7.99998 4.77496 7.99998 5.33301C7.99998 6.11331 7.7971 6.21109 7.44139 6.49056C7.26353 6.6303 7.03057 6.79141 6.83136 7.06283C6.63215 7.33424 6.49998 7.71259 6.49998 8.16634C6.49904 8.2326 6.51128 8.29838 6.53599 8.35986C6.5607 8.42135 6.59738 8.47731 6.6439 8.52449C6.69042 8.57168 6.74586 8.60915 6.80699 8.63472C6.86812 8.66029 6.93372 8.67346 6.99998 8.67346C7.06624 8.67346 7.13184 8.66029 7.19297 8.63472C7.2541 8.60915 7.30954 8.57168 7.35606 8.52449C7.40258 8.47731 7.43926 8.42135 7.46397 8.35986C7.48868 8.29838 7.50092 8.2326 7.49998 8.16634C7.49998 7.88193 7.55531 7.7664 7.63735 7.65462C7.71939 7.54284 7.86143 7.43191 8.05857 7.27702C8.45286 6.96724 8.99998 6.38604 8.99998 5.33301C8.99998 4.23439 8.0986 3.33301 6.99998 3.33301ZM6.99998 9.66634C6.82317 9.66634 6.6536 9.73658 6.52858 9.8616C6.40355 9.98663 6.33331 10.1562 6.33331 10.333C6.33331 10.5098 6.40355 10.6794 6.52858 10.8044C6.6536 10.9294 6.82317 10.9997 6.99998 10.9997C7.17679 10.9997 7.34636 10.9294 7.47138 10.8044C7.59641 10.6794 7.66665 10.5098 7.66665 10.333C7.66665 10.1562 7.59641 9.98663 7.47138 9.8616C7.34636 9.73658 7.17679 9.66634 6.99998 9.66634Z"
                    fill="#C6C6D1"
                  />
                </svg>
              </span>
            </label>
            <div
              v-if="isInfoModal"
              class="
                info-model
                bg-white
                pl-4
                pr-4
                pt-3
                pb-4
                absolute
                right-0
                w-75
                z-50
              "
            >
              <label class="flex justify-between items-center mb-1">
                <span
                  class="text block font-bold text-sm text-darkgray block w-4/6"
                >
                  {{ $t("pages.questionnaire.second_collapse.info.heading") }}
                </span>
                <span class="flex justify-end items-center w-2/6">
                  <span @click="isInfoModal = false">
                    <svg
                      width="16"
                      height="16"
                      class="w-4 h-4"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.1622 2.32631C13.0301 2.32943 12.9047 2.38467 12.8132 2.47996L8.00008 7.29311L3.18693 2.47996C3.14032 2.43196 3.08456 2.39381 3.02294 2.36775C2.96132 2.34169 2.8951 2.32827 2.8282 2.32826C2.7287 2.32829 2.63146 2.358 2.54893 2.4136C2.46641 2.4692 2.40234 2.54815 2.36494 2.64036C2.32754 2.73257 2.3185 2.83385 2.33898 2.93122C2.35946 3.0286 2.40852 3.11765 2.4799 3.18699L7.29305 8.00014L2.4799 12.8133C2.43191 12.8594 2.3936 12.9146 2.36721 12.9756C2.34082 13.0367 2.32687 13.1024 2.3262 13.1689C2.32552 13.2354 2.33812 13.3014 2.36327 13.363C2.38841 13.4246 2.42559 13.4805 2.47263 13.5276C2.51967 13.5746 2.57562 13.6118 2.63721 13.637C2.6988 13.6621 2.76479 13.6747 2.83131 13.674C2.89783 13.6733 2.96354 13.6594 3.02461 13.633C3.08567 13.6066 3.14085 13.5683 3.18693 13.5203L8.00008 8.70717L12.8132 13.5203C12.8593 13.5683 12.9145 13.6066 12.9755 13.633C13.0366 13.6594 13.1023 13.6733 13.1688 13.674C13.2354 13.6747 13.3014 13.6621 13.3629 13.6369C13.4245 13.6118 13.4805 13.5746 13.5275 13.5276C13.5746 13.4805 13.6117 13.4246 13.6369 13.363C13.662 13.3014 13.6746 13.2354 13.674 13.1689C13.6733 13.1024 13.6593 13.0367 13.6329 12.9756C13.6066 12.9146 13.5682 12.8594 13.5203 12.8133L8.70711 8.00014L13.5203 3.18699C13.593 3.1172 13.6429 3.02707 13.6635 2.92842C13.6841 2.82977 13.6744 2.72719 13.6357 2.63414C13.597 2.54109 13.531 2.46191 13.4466 2.40698C13.3621 2.35205 13.2629 2.32393 13.1622 2.32631Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                </span>
              </label>
              <div
                class="situation-item flex items-center justify-start mb-1.5"
              >
                <div class="w-2/6">
                  <label class="flex items-start justify-start">
                    <fa-rating
                      :glyph="thumbsUp"
                      :rating="4"
                      :max-rating="4"
                      :spacing="3"
                      border-color="#e5e7eb"
                      active-color="#63B15B"
                      :show-rating="false"
                      :item-size="10"
                      :read-only="true"
                    >
                    </fa-rating>

              
                  </label>
                </div>
                <div class="w-4/6 flex items-start justify-end">
                  <label
                    class="
                      block
                      relative
                      text-sm
                      font-normal
                      text-darkgray1
                    "
                  >
                    {{ $t(`pages.questionnaire.second_collapse.info.text1`) }}
                  </label>
                </div>
              </div>

              <div
                class="situation-item flex items-center justify-start mb-1.5"
              >
                <div class="w-2/6">
                  <label class="flex items-start justify-start">
                    <fa-rating
                      :glyph="thumbsUp"
                      :rating="3"
                      :spacing="3"
                      :max-rating="4"
                      border-color="#e5e7eb"
                      active-color="#A5C843"
                      :show-rating="false"
                      :item-size="10"
                      :read-only="true"
                    >
                    </fa-rating>
                  
                  </label>
                </div>
                <div class="w-4/6 flex items-start justify-end">
                  <label
                    class="
                      block
                      relative
                      text-sm
                      font-normal
                      text-darkgray1
                    "
                  >
                    {{ $t(`pages.questionnaire.second_collapse.info.text2`) }}
                  </label>
                </div>
              </div>

              <div
                class="situation-item flex items-center justify-start mb-1.5"
              >
                <div class="w-2/6">
                  <label class="flex items-start justify-start">
                    <fa-rating
                      :glyph="thumbsUp"
                      :rating="2"
                      :spacing="3"
                      :max-rating="4"
                      border-color="#e5e7eb"
                      active-color="#FFD600"
                      :show-rating="false"
                      :item-size="10"
                      :read-only="true"
                    >
                    </fa-rating>
                 
                  </label>
                </div>
                <div class="w-4/6 flex items-start justify-end">
                  <label
                    class="
                      block
                      relative
                      text-sm
                      font-normal
                      text-darkgray1
                    "
                  >
                    {{ $t(`pages.questionnaire.second_collapse.info.text3`) }}
                  </label>
                </div>
              </div>

              <div
                class="situation-item flex items-center justify-start mb-1.5"
              >
                <div class="w-2/6">
                  <label class="flex items-start justify-start">
                    <fa-rating
                      :glyph="thumbsUp"
                      :rating="1"
                      :spacing="3"
                      :max-rating="4"
                      border-color="#e5e7eb"
                      active-color="#EE5B64"
                      :show-rating="false"
                      :item-size="10"
                      :read-only="true"
                    >
                    </fa-rating>
                   
                  </label>
                </div>
                <div class="w-4/6 flex items-start justify-end">
                  <label
                    class="
                      block
                      relative
                      text-sm
                      font-normal
                      text-darkgray1
                    "
                  >
                    {{ $t(`pages.questionnaire.second_collapse.info.text4`) }}
                  </label>
                </div>
              </div>
            </div>

            <div class="situation-item flex items-center justify-start mb-1.5">
              <div class="w-2/6">
                <label
                  class="
                    block
                    relative
                    text-sm
                    font-normal
                    text-darkgray1
                  "
                >
                  {{ $t("pages.questionnaire.second_collapse.text1") }}
                </label>
              </div>
              <div class="w-4/6 flex items-start justify-end">
                <label class="flex items-start justify-end">
                  <fa-rating
                    :glyph="thumbsUp"
                    v-model="patient.capabilities.can_hear"
                    :max-rating="4"
                    :spacing="3"
                    border-color="#e5e7eb"
                    :active-color="
                      patient.capabilities.can_hear == 1
                        ? '#EE5B64'
                        : patient.capabilities.can_hear == 2
                        ? '#FFD600'
                        : patient.capabilities.can_hear == 3
                        ? '#A5C843'
                        : patient.capabilities.can_hear == 4
                        ? '#63B15B'
                        : ''
                    "
                    :show-rating="false"
                    :item-size="10"
                    :read-only="true"
                  >
                  </fa-rating>
                
                </label>
              </div>
            </div>

            <div class="situation-item flex items-center justify-start mb-1.5">
              <div class="w-4/6">
                <label
                  class="
                    block
                    relative
                    text-sm
                    font-normal
                    text-darkgray1
                  "
                >
                  {{ $t("pages.questionnaire.second_collapse.text2") }}
                </label>
              </div>
              <div class="w-2/6 flex items-start justify-end">
                <label class="flex items-start justify-end">
                  <fa-rating
                    :glyph="thumbsUp"
                    v-model="patient.capabilities.can_speak"
                    :max-rating="4"
                    border-color="#e5e7eb"
                    :spacing="3"
                    :active-color="
                      patient.capabilities.can_speak == 1
                        ? '#EE5B64'
                        : patient.capabilities.can_speak == 2
                        ? '#FFD600'
                        : patient.capabilities.can_speak == 3
                        ? '#A5C843'
                        : patient.capabilities.can_speak == 4
                        ? '#63B15B'
                        : ''
                    "
                    :show-rating="false"
                    :item-size="10"
                    :read-only="true"
                  >
                  </fa-rating>
               
                </label>
              </div>
            </div>

            <div class="situation-item flex items-center justify-start mb-1.5">
              <div class="w-4/6">
                <label
                  class="
                    block
                    relative
                    text-sm
                    font-normal
                    text-darkgray1
                  "
                >
                  {{ $t("pages.questionnaire.second_collapse.text3") }}
                </label>
              </div>
              <div class="w-2/6 flex items-start justify-end">
                <label class="flex items-start justify-end">
                  <fa-rating
                    :glyph="thumbsUp"
                    v-model="patient.capabilities.can_see"
                    :max-rating="4"
                    border-color="#e5e7eb"
                    :spacing="3"
                    :active-color="
                      patient.capabilities.can_see == 1
                        ? '#EE5B64'
                        : patient.capabilities.can_see == 2
                        ? '#FFD600'
                        : patient.capabilities.can_see == 3
                        ? '#A5C843'
                        : patient.capabilities.can_see == 4
                        ? '#63B15B'
                        : ''
                    "
                    :show-rating="false"
                    :item-size="10"
                    :read-only="true"
                  >
                  </fa-rating>
                
                </label>
              </div>
            </div>

            <div class="situation-item flex items-center justify-start mb-1.5">
              <div class="w-4/6">
                <label
                  class="
                    block
                    relative
                    text-sm
                    font-normal
                    text-darkgray1
                  "
                >
                  {{ $t("pages.questionnaire.second_collapse.text4") }}
                </label>
              </div>
              <div class="w-2/6 flex items-start justify-end">
                <label class="flex items-start justify-end">
                  <fa-rating
                    :glyph="thumbsUp"
                    v-model="patient.capabilities.can_climb_stairs"
                    :max-rating="4"
                    border-color="#e5e7eb"
                    :spacing="3"
                    :active-color="
                      patient.capabilities.can_climb_stairs == 1
                        ? '#EE5B64'
                        : patient.capabilities.can_climb_stairs == 2
                        ? '#FFD600'
                        : patient.capabilities.can_climb_stairs == 3
                        ? '#A5C843'
                        : patient.capabilities.can_climb_stairs == 4
                        ? '#63B15B'
                         : patient.capabilities.can_climb_stairs == 5
                        ? '#63B15B'
                        : ''
                    "
                    :show-rating="false"
                    :item-size="10"
                    :read-only="true"
                  >
                  </fa-rating>
                
                </label>
              </div>
            </div>

            <div class="situation-item flex items-center justify-start mb-1.5">
              <div class="w-4/6">
                <label
                  class="
                    block
                    relative
                    text-sm
                    font-normal
                    text-darkgray1
                  "
                >
                  {{ $t("pages.questionnaire.second_collapse.text5") }}
                </label>
              </div>
              <div class="w-2/6 flex items-start justify-end">
                <label class="flex items-start justify-end">
                  <fa-rating
                    :glyph="thumbsUp"
                    v-model="patient.capabilities.can_get_on_off_bed"
                    :max-rating="4"
                    :spacing="3"
                    border-color="#e5e7eb"
                    :active-color="
                      patient.capabilities.can_get_on_off_bed == 1
                        ? '#EE5B64'
                        : patient.capabilities.can_get_on_off_bed == 2
                        ? '#FFD600'
                        : patient.capabilities.can_get_on_off_bed == 3
                        ? '#A5C843'
                        : patient.capabilities.can_get_on_off_bed == 4
                        ? '#63B15B'
                        : ''
                    "
                    :show-rating="false"
                    :item-size="10"
                    :read-only="true"
                  >
                  </fa-rating>
               
                </label>
              </div>
            </div>

            <div class="situation-item flex items-center justify-start mb-1.5">
              <div class="w-4/6">
                <label
                  class="
                    block
                    relative
                    text-sm
                    font-normal
                    text-darkgray1
                  "
                >
                  {{ $t("pages.questionnaire.second_collapse.text6") }}
                </label>
              </div>
              <div class="w-2/6 flex items-start justify-end">
                <label class="flex items-start justify-end">
                  <fa-rating
                    :glyph="thumbsUp"
                    v-model="patient.capabilities.can_dress"
                    :max-rating="4"
                    :spacing="3"
                    border-color="#e5e7eb"
                    :active-color="
                      patient.capabilities.can_dress == 1
                        ? '#EE5B64'
                        : patient.capabilities.can_dress == 2
                        ? '#FFD600'
                        : patient.capabilities.can_dress == 3
                        ? '#A5C843'
                        : patient.capabilities.can_dress == 4
                        ? '#63B15B'
                        : ''
                    "
                    :show-rating="false"
                    :item-size="10"
                    :read-only="true"
                  >
                  </fa-rating>
                  
                </label>
              </div>
            </div>

            <div class="situation-item flex items-center justify-start mb-1.5">
              <div class="w-4/6">
                <label
                  class="
                    block
                    relative
                    text-sm
                    font-normal
                    text-darkgray1
                  "
                >
                  {{ $t("pages.questionnaire.second_collapse.text7") }}
                </label>
              </div>
              <div class="w-2/6 flex items-start justify-end">
                <label class="flex items-start justify-end">
                  <fa-rating
                    :glyph="thumbsUp"
                    v-model="patient.capabilities.can_walk"
                    :max-rating="4"
                    border-color="#e5e7eb"
                    :spacing="3"
                    :active-color="
                      patient.capabilities.can_walk == 1
                        ? '#EE5B64'
                        : patient.capabilities.can_walk == 2
                        ? '#FFD600'
                        : patient.capabilities.can_walk == 3
                        ? '#A5C843'
                        : patient.capabilities.can_walk == 4
                        ? '#63B15B'
                        : ''
                    "
                    :show-rating="false"
                    :item-size="10"
                    :read-only="true"
                  >
                  </fa-rating>
                 
                </label>
              </div>
            </div>

            <div class="situation-item flex items-center justify-start">
              <div class="w-4/6">
                <label
                  class="
                    block
                    relative
                    text-sm
                    font-normal
                    text-darkgray1
                  "
                >
                  {{ $t("pages.questionnaire.second_collapse.text8") }}
                </label>
              </div>
              <div class="w-2/6 flex items-start justify-end">
                <label class="flex items-start justify-end">
                  <fa-rating
                    :glyph="thumbsUp"
                    v-model="patient.capabilities.can_stand"
                    :max-rating="4"
                    border-color="#e5e7eb"
                    :spacing="3"
                    :active-color="
                      patient.capabilities.can_stand == 1
                        ? '#EE5B64'
                        : patient.capabilities.can_stand == 2
                        ? '#FFD600'
                        : patient.capabilities.can_stand == 3
                        ? '#A5C843'
                        : patient.capabilities.can_stand == 4
                        ? '#63B15B'
                        : ''
                    "
                    :show-rating="false"
                    :item-size="10"
                    :read-only="true"
                  >
                  </fa-rating>
                 
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FaRating } from "vue-rate-it";
import Circle from "vue-rate-it/glyphs/circle-o";

export default {
  name: "HealthConditionDetails",
  components: { FaRating },

  props: {
    patient: {
      default: () => {},
      type: Object,
    },
    glyph: {
      type: String,
    },
  },
  data() {
    return {
      isInfoModal: false,
      rating: 3,
      mouseOver: null,
      src: "https://craigh411.github.io/vue-rate-it/images/vueLogo.png",
      thumbsUp: Circle,
    };
  },
  created() {},
};
</script>

<style>
.info-model {
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.16), 0px 0px 1px rgba(0, 0, 0, 0.04);
  border-radius: 10px;
}
div[class^="circle"] {
  background: white;
  border-radius: 100%;
  display: inline-block;
  height: 20px;
  width: 20px;
  overflow: hidden;
  position: relative;
}
div[class^="circle"]:after {
  content: "";
  position: absolute;
  display: block;
  height: 100%;
  left: 0;
  background: orange;
}
div.circle25:after {
  width: 25%;
}
div.circle50:after {
  width: 50%;
}
div.circle75:after {
  width: 75%;
}
div.circle100:after {
  width: 100%;
}
</style>
